import { defineEntity, custom } from './_helpers.js';

export default defineEntity('consentRecord', {
    expired: custom({ scope: 'state' }),
});
